const toISODateString = date => {
  if (date) {
    const ye = date.getFullYear();
    const mo = `0${date.getMonth() + 1}`.slice(-2);
    const da = `0${date.getDate()}`.slice(-2);

    return `${ye}-${mo}-${da}`;
  }

  throw new Error('A data não foi informada');
};

export { toISODateString };
